import { buildPermission } from "portal/utils/auth";
import { Farm } from "./farm/Farm";
import { FarmList } from "./FarmList";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { ShapefileBundleImport } from "./farm/shapefile-import/ShapefileBundleImport";
import { UnauthorizedPage } from "portal/components/UnauthorizedPage";
import { useRoutes } from "react-router-dom";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

const _Farms: FunctionComponent = () => {
  return useRoutes([
    { path: "/", element: <FarmList /> },
    { path: "/import-shapefiles", element: <ShapefileBundleImport /> },
    { path: "/:farmId", element: <Farm /> },
  ]);
};

export const Farms = withAuthorizationRequired(
  {
    or: [
      buildPermission(
        PermissionAction.read,
        PermissionResource.farms,
        PermissionDomain.customer
      ),
      buildPermission(
        PermissionAction.read,
        PermissionResource.farms,
        PermissionDomain.all
      ),
    ],
  },
  _Farms,
  <UnauthorizedPage />
);
